module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-info"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": ("Signup & " + _vm.year + " Teams")
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('info', 'info-sign-up')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": require("../assets/ic_info.svg"),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Signup\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('info', 'info-prize')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": require("../assets/ic_prize.svg"),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Prize\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('teams', 'info-teams')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": require("../assets/ic_team.svg"),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(_vm.year) + " Teams\n            ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('about-sign-up-sub-section', {
    attrs: {
      "id": "info-sign-up"
    }
  }), _vm._v(" "), _c('about-prize-sub-section', {
    attrs: {
      "id": "info-prize",
      "name": "bosshog::about-prize",
      "is-alt": "true"
    }
  }), _vm._v(" "), _c('about-prize-awards-sub-section', {
    attrs: {
      "id": "info-prize-awards",
      "name-like": ['bosshog::about-prize-award']
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a080eafe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Info.vue
// module id = 930
// module chunks = 1